/**
 * Instance Pinia partagée.
 *
 * Exportée depuis un module dédié pour pouvoir être utilisée AUSSI en dehors des
 * composants (router guards, helpers utilitaires). Dans ces contextes, il n'y a pas
 * de « pinia actif » implicite : on passe donc explicitement cette instance aux
 * stores, ex. `useOrderWorkflowsStore(pinia)`.
 *
 * Coexiste avec Vuex pendant la migration progressive. `main.js` enregistre
 * `PiniaVuePlugin` puis fournit cette instance à l'instance racine de Vue.
 */
import { createPinia, setActivePinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Marque cette instance comme « pinia actif ». Indispensable en Vue 2.7 pour que
// TOUTES les voies de résolution pointent vers le MÊME store :
//  - helpers Options API dans les composants (mapState/mapActions)
//  - appels hors composant avec instance explicite (useStore(pinia))
//  - appels hors composant sans argument (useStore() → getActivePinia())
// Sans cela, un écrit hors composant (ex: router guard) et une lecture dans un
// composant peuvent viser deux stores différents → état vide côté composant.
setActivePinia(pinia)

export default pinia
